import { getBaseUrl } from '../utils/getBaseUrl'; 
const getRelatedPostURL = getBaseUrl() + 'post/relatedpost';
const getPrevNextPostURL = getBaseUrl() + 'post/prevnextpost';
const getRandomPostURL = getBaseUrl() + 'post/randompost';
const getMultipleRandomPostURL = getBaseUrl() + 'post/randompostmultiple';
const getPostMetaURL = getBaseUrl() + 'meta/getpagemtea';  
const getPostTagsURL = getBaseUrl() + 'posttag/getall';  

const getAllPostURL = getBaseUrl() + 'post/getpublished';
const getPostBySlugURL = getBaseUrl() + 'post/getbyslug';
const getPostByCategoryURL = getBaseUrl() + 'post/getbycategory';
const getPostByCategorySlugURL = getBaseUrl() + 'post/getbycategoryslug';
const getPostByTag = getBaseUrl() + 'post/getbytag';
const getRecentPostURL = getBaseUrl() + 'post/recentpost';
const getAllCategoryURL = getBaseUrl() + 'category/getall';
const getTagClound = getBaseUrl() + 'tags/getcloud';
const getContentSlug = getBaseUrl() + 'pages/sectionbyslug';

export const GetAllBlogPost  = async () => {
    try {
        const posts = fetch(getAllPostURL, {
            method: 'GET',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
            body: null
        });
        const postData = await posts;
        const jsonData = await postData.json();
        return jsonData;            
      } catch (error) {
        console.error('Error fetching the all post data:', error);
      }
}

export const GetPostBySlug  = async (postSlug) => {
  
  try {
      const posts = fetch(getPostBySlugURL +"?postSlug="+postSlug, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post by slug data:', error);
    }
}

export const GetPostByCategory  = async (categoryPk) => {
  try 
  {
      const posts = fetch(getPostByCategoryURL +"?categoryPk="+categoryPk, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post by slug data:', error);
    }
}

export const GetPostByCategorySlug  = async (categorySlug) => {
  try {
      const posts = fetch(getPostByCategorySlugURL +"?categorySlug="+categorySlug, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post by slug data:', error);
    }
}

export const GetPostByTag  = async (paramlink) => {
  try {
      const posts = fetch(getPostByTag +"?paramlink="+paramlink, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post by slug data:', error);
    }
}

export const GetRecentBlogPost  = async () => {
  try {
      const recentPosts = fetch(getRecentPostURL, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const recentPostData = await recentPosts;
      const jsonData = await recentPostData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the recent post data:', error);
    }
}

export const GetAllCategory  = async () => {
  try {
      const categories = fetch(getAllCategoryURL, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const categoryData = await categories;
      const jsonData = await categoryData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the category data:', error);
    }
}

export const GetRelatedPost  = async (postSlug) => {
  
  try {
      const posts = fetch(getRelatedPostURL +"?postSlug="+postSlug, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the related post by slug data:', error);
    }
}

export const GetPrevNextPost  = async (postSlug) => {
  
  try {
      const posts = fetch(getPrevNextPostURL +"?postSlug="+postSlug, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the related post by slug data:', error);
    }
}

export const GetPostMeta  = async (postSlug) => {
  
  try {
      const posts = fetch(getPostMetaURL +"?postpk=0&slug="+postSlug, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post meta by slug data:', error);
    }
}

export const GetPostTags  = async (postSlug) => {
  
  try {
      const posts = fetch(getPostTagsURL +"?postpk=0&slug="+postSlug, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post tags by slug:', error);
    }
}

export const GetRandomBlogPost  = async () => {
  try {
      const posts = fetch(getRandomPostURL, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the random post data:', error);
    }
}

export const GetPageContentBySlug  = async (paramlink) => {
  try {
      const pageContent = fetch(getContentSlug +"?slug="+paramlink, {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const pageData = await pageContent;
      const jsonData = await pageData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the post by slug data:', error);
    }
}

export const GetMultipleRandomBlogPost  = async () => {
  try {
      const posts = fetch(getMultipleRandomPostURL +"?limit=7", {
          method: 'GET',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          },
          body: null
      });
      const postData = await posts;
      const jsonData = await postData.json();
      return jsonData;            
    } catch (error) {
      console.error('Error fetching the random post data:', error);
    }
}


export const GetTagCloud  = async () => {
    try {
        const posts = fetch(getTagClound, {
            method: 'GET',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
            body: null
        });
        const tagData = await posts;
        const jsonData = await tagData.json();
        return jsonData;            
      } catch (error) {
        console.error('Error fetching the all post data:', error);
      }
}

export const GetShortString  = async (desc, length) => {
  //sanitise html string
  const sanitisedString =  desc.replace(/(<([^>]+)>)/gi, '');
  //get only required length
  if(sanitisedString.length > length)
  {
    return sanitisedString.substring(0, length) + "...";
  }
  return sanitisedString + "...";
}

export const getRandomLightColor = () => {
  const r = Math.floor(200 + Math.random() * 55);
  const g = Math.floor(200 + Math.random() * 55);
  const b = Math.floor(200 + Math.random() * 55);
  return `rgb(${r}, ${g}, ${b})`;
};